import React, { useState } from 'react';
import axios from 'axios';
import { Container, TextField, Button, Typography } from '@mui/material';
import logo from '../data/logo192.png'; // Adjust the path as necessary

import Snackbar from '@mui/material/Snackbar';
import Alert from '@mui/material/Alert';

const NewPassword = ({ serverCode, onCancel }) => {
  const [newPassword, setNewPassword] = useState("");
  const [confirmPassword, setConfirmPassword] = useState("");
  const [isPasswordMatching, setIsPasswordMatching] = useState(true);
  const [errorMessage, setErrorMessage] = useState("");
  const [openSnackbar, setOpenSnackbar] = useState(false);
  const [snackbarMessage, setSnackbarMessage] = useState("");
  const [passwordLengthValid, setPasswordLengthValid] = useState(true);

  const buttonStyles = {
    backgroundColor: 'var(--black1)',
    color: 'var(--yellow1)',
    '&:hover': {
      backgroundColor: 'var(--black2)', // Adjust as needed for hover state
    },
    '&:focus': {
      backgroundColor: 'var(--black1)', // Keep button black on focus
      color: 'var(--yellow1)', // Ensure text color remains the same
    },
    marginTop: '8px', // Add spacing between this button and the one above it
  };
  
  const outlinedButtonStyles = {
    borderColor: 'var(--black1)',
    color: 'var(--black1)',
    '&:hover': {
      backgroundColor: 'var(--gray1)', // Optional: Define a hover state for outlined button
    },
    marginBottom: '8px',
    marginTop: '8px',
  };

  const handleCloseSnackbar = (event, reason) => {
    if (reason === 'clickaway') {
      return;
    }
  
    setOpenSnackbar(false);
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (!isPasswordMatching) {
      return;
    }
    
    
    try {
      
      const response = await axios.post('https://api.splitdiscount.com/api/auth/reset-password', {
        code: serverCode,
        password: newPassword,
        passwordConfirmation: newPassword 
      });

      if (response.status === 200) {
        setSnackbarMessage("Password reset successfull.");
        setOpenSnackbar(true);
        setTimeout(onCancel, 1500);

      }
    } catch (err) {
      setErrorMessage("We got some error, contact support.");
    }
  };

  const handlePasswordChange = (e) => {
    setNewPassword(e.target.value);
    setIsPasswordMatching(e.target.value === confirmPassword);
    setPasswordLengthValid(e.target.value.length >= 6); 

  };

  const handleConfirmPasswordChange = (e) => {
    setConfirmPassword(e.target.value);
    setIsPasswordMatching(newPassword === e.target.value);
  };

  return (
    <Container 
      component="main" 
      maxWidth="xs" 
      className="flex flex-col items-center justify-center min-h-screen bg-gray-100"
    >
      <div className='mt-[-40%] sm:mt-[-25%] md:sm:mt-[-20%]'>
        <div className="my-10 flex flex-col items-center">
          <img src={logo} alt="Logo" className="h-14 w-14 mb-2 mt-2" />
          <span className="text-gray-700 animate-sailInFromLeft">STdiscount</span>
        </div>
        <div className="p-8 flex flex-col items-center bg-white shadow-lg rounded-md">
          <Typography component="h1" variant="h5" className="mb-4">
            Password reset
          </Typography>
          <form className="w-full mt-2" onSubmit={handleSubmit} noValidate>
            <TextField
              variant="outlined"
              margin="normal"
              required
              fullWidth
              id="newPassword"
              label="New Password"
              name="newPassword"
              type="password"
              className="mb-4"
              value={newPassword}
              onChange={handlePasswordChange}
            />
            <TextField
              variant="outlined"
              margin="normal"
              required
              fullWidth
              id="confirmPassword"
              label="Confirm Password"
              name="confirmPassword"
              type="password"
              error={!passwordLengthValid || !isPasswordMatching}
              helperText={
                !passwordLengthValid
                ? "Has to have at last 6 characters!"
                : !isPasswordMatching
                ? "Passwords do not match!"
                : ""
              }
              className="mb-4"
              value={confirmPassword}
              onChange={handleConfirmPasswordChange}
            />
            {/* Display error message */}
            {errorMessage && <Typography variant="body2" color="error">{errorMessage}</Typography>}
            
            <Button
              fullWidth
              variant="outlined"
              sx={outlinedButtonStyles}
              onClick={onCancel}
            >
              Cancel
            </Button>

            <Button
            type="submit"
            fullWidth
            variant="contained"
            sx={buttonStyles}
          >
            Confirm
          </Button>
          </form>
        </div>
      </div>

      <Snackbar
        open={openSnackbar}
        autoHideDuration={5000}
        onClose={handleCloseSnackbar}
        anchorOrigin={{ vertical: 'bottom', horizontal: 'left' }}
      >
        <Alert onClose={handleCloseSnackbar} severity="success" sx={{ width: '100%' }}>
          {snackbarMessage}
        </Alert>
      </Snackbar>

    </Container>
  );
};

export default NewPassword;
